/* [BRAND NAME] "The Archive" motion: viewport reveals + scroll-progress variables. No dependencies. */
(function () {
  var root = document.documentElement;
  var motion = root.classList.contains('ar-motion');
  var items = [];

  function collect() {
    items = [].slice.call(document.querySelectorAll('[data-ar-progress]'));
  }
  collect();

  // Without motion every progress-driven element simply shows its final state (CSS falls back to --p: 1).
  if (!motion) return;

  // ---- One-shot reveals ----
  // An element fully hidden by its own clip-path never reports as intersecting,
  // so data-ar="clip" elements are watched through their (unclipped) parent.
  var io = null;
  var watched = new Map();
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          (watched.get(entry.target) || []).forEach(function (el) {
            el.classList.add('is-in');
          });
          watched.delete(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );
  }
  function observe(scope) {
    var els = (scope || document).querySelectorAll('[data-ar]:not(.is-in)');
    els.forEach(function (el) {
      if (!io) return el.classList.add('is-in');
      var target = el.getAttribute('data-ar') === 'clip' && el.parentElement ? el.parentElement : el;
      if (!watched.has(target)) {
        watched.set(target, []);
        io.observe(target);
      }
      watched.get(target).push(el);
    });
  }
  observe();
  root.classList.add('ar-ready');

  // ---- Scroll progress: --p goes 0 -> 1 as an element travels from the bottom of the viewport
  // to data-ar-end (fraction of viewport height, default 0.35). rAF-throttled, passive.
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) continue;
      var end = vh * (parseFloat(el.getAttribute('data-ar-end')) || 0.35);
      var p = (vh - r.top) / (vh - end);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      el.style.setProperty('--p', p.toFixed(3));
    }
  }
  function request() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  // capture phase also catches scroll containers other than the window
  document.addEventListener('scroll', request, { passive: true, capture: true });
  window.addEventListener('resize', request);
  update();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
    collect();
    request();
  });
})();
